export const generateBreadcrumbSchema = (
  title: string,
  url: string,
  domain_url: string | undefined,
  type: "blogs" | "news",
  name: "Blogs" | "News"
) => {
  if (!title || !url || !type) return [];

  return [
    {
      "@type": "ListItem",
      position: 1,
      name: "Collegehai Home",
      item: `${domain_url}/`,
    },
    {
      "@type": "ListItem",
      position: 2,
      name: name,
      item: `${domain_url}/${type}`,
    },
    {
      "@type": "ListItem",
      position: 3,
      name: title,
      item: url,
    },
  ];
};
